// extracted by mini-css-extract-plugin
export default {"image-text":"image-text-dab1"};